import { Dot } from 'lucide-react';
import { useMemo } from 'react';
import { useScreenSize } from '~/common/hooks/useScreenSize';
import { cn } from '~/common/utils/styleUtil';
import { toKeyedItems } from '~/common/utils/keyedItems';

export interface ArticleInfoItem {
  label: string;
  value: string;
}

export interface ArticleInfoListProps {
  items: ArticleInfoItem[];
}

export function ArticleInfoList({items}:Readonly<ArticleInfoListProps>) {
  const {isMobile} = useScreenSize();
  
  const infoItems: any[] = useMemo(() => {
    const flatItems: any[] = [];
    toKeyedItems(items.filter(x => x.value?.length > 0), x => x.label).forEach(({ key, item }) => {
      if (isMobile) {
        flatItems.push(<div key={key} className={"flex flex-col"}>
          <div className={"text-sm text-secondary"}>{item.label}</div>
          <div>{item.value}</div>
        </div>);
      } else {
        if (flatItems.length > 0) {
          flatItems.push(
            <div key={`${key}-label`} className={'flex'}>
              <Dot />
              {`${item.label}:`}&nbsp;
            </div>
          );
        } else {
          flatItems.push(<div key={`${key}-label`}>{`${item.label}:`}&nbsp;</div>);
        }
        flatItems.push(<div key={`${key}-value`}>{item.value}</div>);
      }
    })
    return flatItems;
  }, [isMobile, items]);

  return <div className={cn("flex flex-wrap mb-4 gap-4 desktop:gap-0")} data-testid={`article-info`}>
    {infoItems}
  </div>
}